import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormsModule } from '@angular/forms';
import { NgSelectComponent, NgMultiLabelTemplateDirective, NgOptgroupTemplateDirective, NgOptionTemplateDirective } from '@ng-select/ng-select';
import { TranslationService, UrlPipe, I18nModule } from '@spartacus/core';
import moment from 'moment';
import { IDateRange, IDateRangePickerOptions } from 'ngx-daterange';
import { FilterSortModel } from 'src/app/core/model/filter-sort.model';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { CustomProductsService } from '../custom-products/custom-products.service';
import { Router, RouterLink } from '@angular/router';
import InventoryManagementService from '../inventory-unpublished-batch/inventory-management.service';
import { response } from 'express';
import { map } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { NgIf, NgClass, NgFor } from '@angular/common';
import { InventoryUnpublishedBatchComponent } from '../inventory-unpublished-batch/inventory-unpublished-batch.component';
@Component({
    selector: 'app-custom-inventory-management',
    templateUrl: './custom-inventory-management.component.html',
    styleUrls: ['./custom-inventory-management.component.scss'],
    imports: [RouterLink, NgIf, NgSelectComponent, FormsModule, NgMultiLabelTemplateDirective, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgClass, NgFor, InventoryUnpublishedBatchComponent, UrlPipe, I18nModule]
})
export class CustomInventoryManagementComponent implements OnInit {
  @ViewChild(NgSelectComponent) ngSelectComponent: NgSelectComponent;
  @ViewChild('testselect') private myselect: NgSelectComponent;
  filterSortModel: FilterSortModel;
  selectedPort;
  selectedPortTest;
  selectedProductType;
  selectedProduct;
  ports = [];
  searchInput = '';
  sampleProduct = [];
  samplePort = [];
  sampleProductName = [];
  data: any;
  query: string = null;
  filterListSelected = [];
  selectedPortsList = [];
  productTypes = [];
  hidebutton = false;
  productsList = [];
  loggedinUser: any;
  customerId: any;
  pageSize = 5;
  currentPage = 1;
  Title='BHP Connect - Inventory Management';
  sidebar: boolean;
  form: UntypedFormGroup = null;
  checkedform: UntypedFormGroup;
  length: number;
  checkArray: any;
  checkedportform: UntypedFormGroup;
  checkedproductform: UntypedFormGroup;
  checkedproductTypeform: UntypedFormGroup;
  portlength = 0;
  productlength = 0;
  isPortNull = true;
  isTypeNull = true;
  isProductNull = true;
  showClear = false;
  mobileCurrentSelection = null;
  isDisabledCheckBox = false;
  date = 0;
  portLength = 0;
  productLength = 0;
  producttypelength = 0;
  navigationData: string;
  title: any;
  startDate: any = null;
  endDate: any = null;
  loginData: any;
  selectedMaterial: any;

  noData = false;
  searchValue = null;

  activeTab = 'active';
  gridSrc = '/images/grid-view.svg';
  listSrc =  '/images/list-view-orange.svg';
  list = true;
  grid = false;
  selectedSort: any = 'creationTime:desc';
  inventoryTab = 'active';
  unitArray = [];
  translation: any;
  sideBar: boolean;
  firstFieldEmittedValue: IDateRange;
  showUserProfile: any = false;

  constructor(private customProductService: CustomProductsService, private inventoryManagementService: InventoryManagementService,
              private cd: ChangeDetectorRef, private fb: UntypedFormBuilder,private router: Router,private titleService: Title) {
     this.checkedportform = this.fb.group({
      checkArray: this.fb.array([])
     });
     this.checkedproductform = this.fb.group({
       checkArray: this.fb.array([])
    });
     this.checkedproductTypeform = this.fb.group({
      checkArray: this.fb.array([])
    });


}
ngOnInit(): any {
  this.titleService.setTitle(this.Title);
  this.sidebar = true;
  this.inventoryManagementService.languageChange$.subscribe(data => {
    if (data != null) {
      this.selectedPort = null;
      this.selectedProductType = null;
      this.selectedProduct = null;
      this.isPortNull = true;
      this.isTypeNull = true;
      this.isProductNull = true;
      this.customProductService.getFilterInput(null);
      this.currentPage = 0;
      this.pageSize = 2;
      this.customProductService.filterValue = null;
      this.getFacetsData(null);
     // this.productsFilterData();
    }
  });

  this.loginData = JSON.parse(sessionStorage.getItem("loginData"));
  // this.translation.translate('breadcrumb.inventoryManagement.pageTitle').subscribe(res => {
  //     this.title = res;
  //   });
  // this.translation.translate('breadcrumb.inventoryManagement.breadcrumb').subscribe(res => {
  //     this.navigationData = res;
  //   });
  this.form = new UntypedFormGroup({
      secondDateRange: new UntypedFormControl()
    });
 
  }
  // searchQuote(searchWord): any {
  //   this.showClear = false;
  //   this.selectedPort = [];
  //   this.selectedProductType = [];
  //   this.selectedProduct = [];
  //   this.isPortNull = true;
  //   this.isTypeNull = true;
  //   this.isProductNull = true;
  //   this.productsFilterData();
  //   this.customProductService.filterValue = searchWord;
  //   this.customProductService.getSearchInput(searchWord);
  //   this.portlength = 0;
  //   this.productlength = 0;
  //   this.producttypelength = 0;
  //   this.length = 0;
  // }

  // getProductTypeAndproductByPort(query): any {
  //   this.customProductService.getBrowseByPortsData(0, 20 , 'relevance', query).subscribe(data => {
  //     this.data = data;
  //     this.cd.detectChanges();
  //     this.sampleProduct = [];
  //     this.samplePort = [];
  //     this.sampleProductName = [];
  //     this.selectedProductType = [];
  //     this.selectedProduct = [];
  //     this.selectedPort = [];
  //     this.productTypes = [];
  //     this.productsList = [];
  //     for (const item of this.data.facets) {
  //       if (item.name === 'portName') {
  //         for (const values of item.values) {
  //          // const portUrl = values.query.url.split('=');
  //          if (values.selected){
  //            this.selectedPort.push(values.query.query.value);
  //          }
  //          this.samplePort.push({
  //             id: values.query.query.value,
  //             ports: 'Ports',
  //             name: values.name,
  //             selected: values.selected
  //           });
  //          this.ports = this.samplePort;
  //         }
  //       }
  //       if (item.name === 'productType') {
  //         for (const values of item.values) {
  //           this.sampleProduct.push({
  //             id: values.query.query.value,
  //             name: values.name,
  //             productType: 'Product Types',
  //             selected: values.selected
  //           });
  //           this.productTypes = this.sampleProduct;
  //         }
  //       }
  //       if (item.name === 'baseProductCode') {
  //         for (const values of item.values) {
  //           this.sampleProductName.push({
  //             id: values.query.query.value,
  //             product: 'Products',
  //             name: values.name,
  //             selected: values.selected
  //           });
  //           this.productsList = this.sampleProductName;
  //         }
  //       }
  //     }
  //   });
  //   this.cd.detectChanges();
  //   this.producttypelength = 0;
  // }
  // getProductItemByProductType(query): any {
  //   this.customProductService.getProducts(this.currentPage, this.pageSize, 'relevance', query).subscribe(data => {
  //     this.data = data;
  //     this.cd.detectChanges();
  //     this.sampleProductName = [];
  //     this.sampleProduct = [];
  //     this.samplePort = [];
  //     this.sampleProductName = [];
  //     for (const item of this.data.facets) {
  //       if (item.name === 'portName') {
  //         for (const values of item.values) {
  //          // const portUrl = values.query.url.split('=');
  //          this.samplePort.push({
  //             id: values.query.query.value,
  //             ports: 'Ports',
  //             name: values.name,
  //             selected: values.selected
  //           });
  //          this.ports = this.samplePort;
  //         }
  //       }
  //       if (item.name === 'productType') {
  //         for (const values of item.values) {
  //           this.sampleProduct.push({
  //             id: values.query.query.value,
  //             name: values.name,
  //             productType: 'Product Types',
  //             selected: values.selected
  //           });
  //           this.productTypes = this.sampleProduct;
  //         }
  //       }
  //       if (item.name === 'baseProductCode') {
  //         for (const values of item.values) {
  //           this.sampleProductName.push({
  //             id: values.query.query.value,
  //             product: 'Products',
  //             name: values.name,
  //             selected: values.selected
  //           });
  //           this.productsList = this.sampleProductName;
  //         }
  //       }
  //     }
  //   });
  //   this.productlength = 0;
  // }
  // productsFilterData(): any {
  //   this.customProductService.getProducts(this.currentPage, this.pageSize).subscribe(data => {
  //     this.data = data;
  //     this.cd.detectChanges();
  //     this.sampleProduct = [];
  //     this.samplePort = [];
  //     this.sampleProductName = [];
  //     for (const item of this.data.facets) {
  //       if (item.name === 'productType') {
  //         for (const values of item.values) {
  //           this.sampleProduct.push({
  //             id: values.query.query.value,
  //             name: values.name,
  //             productType: 'Product Types',
  //             selected: values.selected
  //           });
  //           this.productTypes = this.sampleProduct;
  //         }
  //       }
  //       if (item.name === 'portName') {
  //         for (const values of item.values) {
  //          // const portUrl = values.query.url.split('=');
  //          this.samplePort.push({
  //             id: values.query.query.value,
  //             ports: 'Ports',
  //             name: values.name,
  //             selected: values.selected
  //           });

  //          this.ports = this.samplePort;
  //         }
  //       }
  //       if (item.name === 'baseProductCode') {
  //         for (const values of item.values) {
  //           this.sampleProductName.push({
  //             id: values.query.query.value,
  //             product: 'Products',
  //             name: values.name,
  //             selected: values.selected
  //           });
  //           this.productsList = this.sampleProductName;
  //         }
  //       }

  //     }
  //   });
  // }
  ngOnDestroy() {
    this.customProductService.filterValue = null;
    this.customProductService.getFilterInput(null);
  }
  clearAllFilter(): any {
    this.showClear = false;
    this.selectedPort = null;
    this.selectedProductType = null;
    this.selectedProduct = null;
    this.isPortNull = true;
    this.isTypeNull = true;
    this.isProductNull = true;
    this.query = null;
    this.inventoryManagementService.getFilterInput(null);
    this.currentPage = 0;
    this.pageSize = 2;
    this.getFacetsData(null);
   // this.getProductItemByProductType(null);
   // this.getProductTypeAndproductByPort(null);
    // this.ngSelectComponent.handleClearClick();
  }

  omit_special_char(event): any {
    if(this.searchValue?.length>=2){
      this.selectedPort = null;
      this.selectedProductType = null;
      this.selectedProduct = null;
      this.query = null;
      this.currentPage = 0;
    }
    const k = event.charCode;
    return this.isValidLetter(k);
  }

  isValidLetter(k): any {
    // return ( (k >= 48 && k <= 57));
    return (k = 47);
  }

  // tslint:disable-next-line:typedef
  filtersidebar() {
    // this.value = document.querySelector('sidebar').width = '295px';
    this.sidebar = false;
  }
  // tslint:disable-next-line:typedef
  closebar() {
    this.sidebar = true;
  }
  submitForm(): any {
    this.closebar();
    //this.length = this.portlength + this.productlength + this.producttypelength;
    if (this.length === 0){
      this.selectedProduct = null;
      this.selectedProductType = null;
      this.selectedPort = null;
    }
  //  this.filteredItemChange();
    this.inventoryManagementService.filterValue = this.mobileCurrentSelection;
    this.inventoryManagementService.getFilterInput(this.query);
  }
  getPortFacets(data): any {
    this.searchInput = null;
    this.getFacetsData(data.id);
    this.inventoryManagementService.filterValue = data.id;
    this.inventoryManagementService.getFilterInput(this.query);
  }
  getTypeFacets(data): any {
    this.searchInput = null;
    this.getFacetsData(data.id);
    this.customProductService.filterValue = data.id;
    this.inventoryManagementService.getFilterInput(this.query);
  }
  getProductsFacet(data): any {
    this.searchInput = null;
    this.getFacetsData(data.id);
   
    this.customProductService.filterValue = data.id;
    this.inventoryManagementService.getFilterInput(this.query);
    // this.myselect.close();
  }
   getFacetsMobile(data): any {
    this.searchInput = null;
    this.getFacetsData(data.id);
    this.mobileCurrentSelection =  data.id;
  }
  getFacetsData(query: string): any {
    if(this.query==null ){
      if(query==null){
        this.query = null
      }else{
        this.query = query;
      }
    }else{
      let itemValue = query.split(':');
      if(this.query?.split(':')?.find((queryParams)=>{
        return queryParams == itemValue[2];
      })== undefined){
        this.query = this.query+query;
      }else{
        let newQArray = this.query.split(':');
        for(let i=0;i<newQArray.length;i++){
          if(newQArray[i] == itemValue[2]){
            newQArray.splice(i-1,2)
            this.query = newQArray.join(':');
            break;
          }
        }
        //this.query = this.query.replace(query,"");
      }
    }
    this.searchValue = null;
    this.inventoryManagementService.getInventoryData(this.currentPage,this.selectedSort,null,null).pipe(map((response:any)=>response.products)).subscribe(data => {
      this.data = data;
      this.showClear = false;
      this.cd.detectChanges();
      this.sampleProduct = [];
      this.samplePort = [];
      this.sampleProductName = [];
      
      this.productTypes = [];
      this.productsList = [];
      this.portlength = 0;
      this.productlength = 0;
      this.producttypelength = 0;
      for(const item of this.data){
        if(item.portName){
          let isSelected = this.isItemSelected?.(this.query,item.portId) || false;
          if(isSelected){
            this.selectedPort.push(':portId:'+item.portId);
            this.showClear = true;
            this.portlength++ ;
          }
          this.samplePort.push({
            name: item.portName,
            ports: 'Ports',
            id: ':portId:'+item.portId,
            selected: isSelected
          })
        }
        if(item.baseProduct){
          let isSelected = this.isItemSelected?.(this.query,item.baseProduct) || false;
          if(isSelected){
            this.selectedProduct.push(':productName:'+item.baseProduct);
            this.showClear = true;
            this.producttypelength++;
          }
          this.sampleProductName.push({
            name: item.baseProduct,
            product: 'Products',
            id: ':productName:'+item.baseProduct,
            selected: isSelected
          })
        }
        if(item.productType){
          let isSelected = this.isItemSelected?.(this.query,item.productType) || false;
          if(isSelected){
            this.selectedProductType.push(':productType:'+item.productType);
            this.showClear = true;
            this.productlength++;
          }
          this.sampleProduct.push({
            name: item.productType,
            productType: 'Product Types',
            id: ':productType:'+item.productType,
            selected: isSelected
          })
        }
        
      }

      this.selectedPort = [...new Set(this.selectedPort)];
      this.selectedProduct = [...new Set(this.selectedProduct)];
      this.selectedProductType = [...new Set(this.selectedProductType)];
      this.ports = this.samplePort.reduce((unique, o) => {
        if(!unique.some(obj => obj.name === o.name && obj.ports === o.ports && obj.id === o.id)){
          unique.push(o);
        }
        return unique;
      },[]);
      this.productsList = this.sampleProductName.reduce((unique, o) => {
        if(!unique.some(obj => obj.name === o.name && obj.product === o.product && obj.id === o.id)){
          unique.push(o);
        }
        return unique;
      },[]);
      this.productTypes = this.sampleProduct.reduce((unique, o) => {
        if(!unique.some(obj => obj.name === o.name && obj.productType === o.productType && obj.id === o.id)){
          unique.push(o);
        }
        return unique;
      },[]);
    })
    // this.customProductService.getProducts(this.currentPage, this.pageSize, 'relevance', query).subscribe(data => {
    //   this.data = data;
    //   this.showClear = false;
    //   this.cd.detectChanges();
    //   this.sampleProduct = [];
    //   this.samplePort = [];
    //   this.sampleProductName = [];
    //   this.selectedProductType = [];
    //   this.selectedProduct = [];
    //   this.selectedPort = [];
    //   this.productTypes = [];
    //   this.productsList = [];
    //   this.portlength = 0;
    //   this.productlength = 0;
    //   this.producttypelength = 0;
    //   for (const item of this.data.facets) {
    //     if (item.name === 'portName') {
    //       for (const values of item.values) {
    //        // const portUrl = values.query.url.split('=');
    //        if (values.selected){
    //         this.selectedPort.push(values.query.query.value);
    //         this.showClear = true;
    //         this.portlength ++;
    //       }
    //        this.samplePort.push({
    //           id: values.query.query.value,
    //           ports: 'Ports',
    //           name: values.name,
    //           selected: values.selected
    //         });
    //        this.ports = this.samplePort;
    //       }
    //     }
    //     if (item.name === 'productType') {
    //       for (const values of item.values) {
    //         if (values.selected){
    //           this.selectedProductType.push(values.query.query.value);
    //           this.showClear = true;
    //           this.productlength ++;
    //         }
    //         this.sampleProduct.push({
    //           id: values.query.query.value,
    //           name: values.name,
    //           productType: 'Product Types',
    //           selected: values.selected
    //         });
    //         this.productTypes = this.sampleProduct;
    //       }
    //     }
    //     if (item.name === 'baseProductCode') {
    //       for (const values of item.values) {
    //         if (values.selected){
    //           this.selectedProduct.push(values.query.query.value);
    //           this.showClear = true;
    //           this.producttypelength ++;
    //         }
    //         this.sampleProductName.push({
    //           id: values.query.query.value,
    //           product: 'Products',
    //           name: values.name,
    //           selected: values.selected
    //         });
    //         this.productsList = this.sampleProductName;
    //       }
    //     }
       
    //   }
    // });
  }

  viewGrid(): void {
    this.gridSrc = '/images/grid-view-orange.svg';
    this.listSrc =  '/images/list-view.svg';
    this.grid = true;
    this.list = false;
  }
  viewList(): any {
    this.listSrc =  '/images/list-view-orange.svg';
    this.gridSrc = '/images/grid-view.svg';
    this.list = true;
    this.grid = false;
  }

  isItemSelected(query: string, item:string){
      let params = query?.split?.(':');
       let value = params?.find?.(paramItem=>{
       return paramItem == item;
    })
    return value!=undefined? true:false;
  }
  changeTab(data, showMsg?): any {
    this.activeTab = data;
    if (this.activeTab === 'active') {
      this.inventoryTab = 'active';
      // show active tab
    }
    else if (this.activeTab === 'completed') {
      // show completed tab
      this.inventoryTab = 'completed';
    }
    else if (this.activeTab === 'archived') {
      // show archieved tab
      this.inventoryTab = 'archived';
    }

  }
  onRangeSelectedMobile(value: IDateRange): void {
  }
  onReset(event: Event): void {
  }

  clearFilterDataMobile(event): void {
    //this.mobileCurrentSelection = null;
    //this.getFacetsData(null);
    //this.inventoryManagementService.getFilterInput(null);
    //this.selectedPort = null;
    //this.selectedProductType = null;
    // this.selectedProduct = null;
    // this.query = null;
    // this.currentPage= 0;
    this.clearAllFilter();
    this.length = null;
    // this.getProductItemByProductType(null);
    //this.searchInput = '';
    }

  
  filterData(): void {

  }

  selectChangeHandler(event: any): void {
    this.selectedSort = event.target.value;
    //this.inventoryManagementService.getInventoryData(this.currentPage,this.selectedSort).subscribe();
  }


  omitSpecialChar(event): any {
    if(this.searchValue?.length>=2){
      this.showClear = false;
      this.selectedPort = null;
      this.selectedProductType = null;
      this.selectedProduct = null;
      this.query = null;
      this.currentPage = 0;
    }
    const k = event.charCode;
    //console.log(event);
    if (k === 46){
    return false;
    }
    return this.isValidLetter(k);
  }

  filterSideBar(): void {
    this.sideBar = false;
  }
  goToUpdatePersonalDetails(){

    this.router.navigate(['profile/my-account/update-personal-details']);
  }
  goToResetPassword(){
  
    this.router.navigate(['profile/my-account/change-password']);
  }
  inventorylogout(){
    sessionStorage.clear();
    this.router.navigate(['inventory/inventorylogin']);
  }
}
